import * as React from "react"
import { Link } from "react-router-dom"
import { useIntl } from "react-intl"
import { useApplicationContext } from "context/applicationContext"

import { Globe } from "@walmart-web/livingdesign-icons"
import { ReactComponent as PhronesisLogo } from "assets/images/logo-phronesis-vertical.svg"

import Loading from "components/Shared/Modals/Loading"
import Dropdown, { dropdownOptionType } from "components/Shared/Dropdown"

import { isAllowedForAlertMessage } from "./isAllowedForAlertMessage"
import UserMenu from "./UserMenu"

import { HOME } from "constants/paths"
import { LANGUAGE_SELECTOR } from "./constants"

import "./Header.scss"
import { concatClassNames } from "helpers/jsxHelpers"
import { IconWrapper } from "components/Shared/IconWrapper"

type HeaderProps = {
	variant?: "primary" | "secondary"
}

const Header: React.FC<HeaderProps> = (props) => {
	const { variant = "primary" } = props
	const intl = useIntl()
	const {
		selectLanguage,
		locale,
		allowedLocales,
		isAuthenticated,
		setShowSampleDataAlerts,
		isLoading,
	} = useApplicationContext()

	const checkIfRouteNotAllowedForAlertMessage = () => {
		const currentRoute = window.location.pathname
		setShowSampleDataAlerts(
			isAllowedForAlertMessage(currentRoute) && isAuthenticated
		)
	}

	const hasMoreThanOneAllowedTranslation =
		Object.keys(allowedLocales).length > 1

	React.useEffect(() => {
		checkIfRouteNotAllowedForAlertMessage()
	}, [window.location.pathname, isAuthenticated])

	const prepareDropdownOptions = (
		selectorType: string,
		collection: object
	): Array<dropdownOptionType> =>
		Object.values(collection).map((element) => ({
			id: element,
			name: intl.formatMessage({
				id: `phronesis.header.${selectorType}.options.${element}`,
			}),
		}))

	return (
		<div className={concatClassNames(["header", variant])}>
			<Loading loading={isLoading} />
			<div className={"header-bottom"}>
				<div className="header-logo">
					<Link to={HOME}>
						<IconWrapper
							size={32}
							icon={PhronesisLogo}
							alt="Phronesis Logo"
							className="header-image"
						/>
					</Link>
				</div>
				<div className="header-option">
					<Dropdown
						buttonName={intl.formatMessage({
							id: `phronesis.header.language.options.${locale}`,
						})}
						buttonIcon={<Globe />}
						onSelectFunction={selectLanguage}
						dropdownOptions={prepareDropdownOptions(
							LANGUAGE_SELECTOR,
							allowedLocales
						)}
						disabled={!hasMoreThanOneAllowedTranslation}
					/>
					{isAuthenticated && <UserMenu />}
				</div>
			</div>
		</div>
	)
}

export default Header
